type fnx = (...args: any[]) => any;

const callAllFns =
  (...fns: fnx[]) =>
  (...args: any[]) => {
    return fns.forEach(fn => fn?.(...args));
  };

export default callAllFns;
